module.exports = __webpack_public_path__ + "img/taizhou.dc08dffa.jpg";